module.exports = __webpack_public_path__ + "img/badge-resident-key.9dc33a26.svg";